export const LockStatusResult = {
    Pending: 'Pending',
    NoAction: 'NoAction',
    Unlocked: 'Unlocked',
    Error: 'Error',
} as const;
export type LockStatusResult = typeof LockStatusResult[keyof typeof LockStatusResult];

export type AccountModel = {
    userId: string;
    resourceId: number;
    resourceName: string;
    isLocked: boolean | null;
    isTapEnabled: boolean;
};

export type VerifiedIdIssuanceModel = {
    status: string;
    issuanceTime: string;
    expirationTime: string;
    requestId: string;
};

export type UserProfileModel = {
    accounts: AccountModel[];
    currentAccountId: number;
    fullName: string;
    firstName: string;
    lastName: string;
    verifiedIdIssuance?: VerifiedIdIssuanceModel | null;
};

export type UserDetailModel = {
    isAuthenticated: boolean;
    userProfile: UserProfileModel | null;
    accounts: AccountModel[];
    passwordRules: string | null;
    sessionTimeoutMinutes: number;
    sessionTimeoutWarningMinutes: number;
    verifiedIdEnabled: boolean;
    tapEnabled: boolean;
    requiresIdentityReauth: boolean;
};
